import React from 'react';

import { Avatar } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import { stringAvatar } from 'common/utils/helpers';

import { AVATAR_SIZE } from './constants';

const ProfileButton = ({ profileValues }) => {
    const profileName = `${get(profileValues, 'first_name', '')} ${get(
        profileValues,
        'last_name',
        '',
    )}`;
    const sx = { fontSize: '16px', height: AVATAR_SIZE, width: AVATAR_SIZE };
    return (
        <>
            {get(profileValues, 'profile_image', '') ? (
                <Avatar
                    alt={profileName}
                    src={get(profileValues, 'profile_image', '')}
                    sx={sx}
                />
            ) : (
                <Avatar {...stringAvatar(profileName)} sx={sx} />
            )}
        </>
    );
};

ProfileButton.propTypes = { profileValues: PropTypes.object };

export default ProfileButton;
